'use client';

import { type FC, useRef } from 'react';

import { cn } from '@/lib/utils';

import type { TableProps } from '@/components/organisms/TableModal/TableModal.types';
import { showOverlayHook } from '@/components/organisms/TableModal/utils/showOverlayHook';
import {
    tableRowVariants,
    tbodyVariants,
} from '@/components/organisms/TableModal/utils/tableVariants';

const DesktopTable: FC<TableProps> = ({
    headers,
    rows,
    className,
    ...props
}) => {
    const tbodyRef = useRef<HTMLTableSectionElement>(null);
    const isOverlayVisible = showOverlayHook(tbodyRef);

    return (
        <table
            {...props}
            className={cn('relative w-full', className)}
        >
            <thead>
                <tr
                    className={cn(tableRowVariants(), 'border-t text-grey-700')}
                >
                    {headers.map((header, i) => (
                        <th
                            key={'desktop-header-' + i}
                            className="w-1/3 text-left text-2xs font-semibold text-grey-700"
                        >
                            {header}
                        </th>
                    ))}
                </tr>
            </thead>

            <tbody
                ref={tbodyRef}
                className={tbodyVariants({ overlay: isOverlayVisible })}
            >
                {rows.map((row, index) => (
                    <tr
                        key={'desktop-row-' + index}
                        className={cn(tableRowVariants())}
                    >
                        {headers.map((header, i) => (
                            <td
                                key={'desktop-value-' + i}
                                className="w-1/3 text-left text-sm font-semibold"
                            >
                                {row[header]}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default DesktopTable;
